// extracted by mini-css-extract-plugin
export default {"div":"User_div__GhOJq"};